// extracted by mini-css-extract-plugin
module.exports = {"indBikeParentDiv":"indBike_indBikeParentDiv__VMROv","bikeDetails":"indBike_bikeDetails__1WHX9","subsDetails":"indBike_subsDetails__2ydQ6","ratesDiv":"indBike_ratesDiv__1w2o9"};